export function trigger(event) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event });
}
